import { createRouter, createWebHashHistory } from "vue-router";
// import store from "@/store";
// import { computed } from "vue";

const routesPC = [
  {
    path: "/",
    redirect: "/product/:fileId",
  },
  {
    path: "/product/:fileId",
    name: "首页",
    component: () =>
      import(/* webpackChunkName: "check" */ "../views/Home/check.vue"),
  },
  {
    path: "/product/:fileId/detail",
    name: "基金产品详情页面",
    component: () =>
      import(/* webpackChunkName: "detail" */ "../views/Home/detail.vue"),
  },

  {
    path: "/:pathMatch(.*)",
    redirect: "/",
  },
];

const routesMobile = [
  {
    path: "/",
    redirect: "/product/:fileId",
  },
  {
    path: "/product/:fileId",
    name: "首页",
    component: () =>
      import(/* webpackChunkName: "check" */ "../views/Home/mobile-check.vue"),
  },
  {
    path: "/product/:fileId/detail",
    name: "基金产品详情页面",
    component: () =>
      import(
        /* webpackChunkName: "detail" */ "../views/Home/mobile-detail.vue"
      ),
  },

  {
    path: "/:pathMatch(.*)",
    redirect: "/",
  },
];

let routes = [];

if (
  /iPad Mini|iPhone 12 Pro|phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian/i.test(
    navigator.userAgent
  )
) {
  routes = routesMobile;
} else {
  routes = routesPC;
}

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  let projectName;
  let existProjectName = setInterval(() => {
    projectName = window.localStorage.getItem("pageTitle");
    if (projectName) clearInterval(existProjectName);
    let pageTitle = window.localStorage.getItem("pageTitle");
    const title =
      to.name == "基金产品详情页面"
        ? // ? "中建三局-公司应收账款资产支持专项计划"
          pageTitle
        : "中金公司资产证券化信息披露专区";
    document.title = title;
  }, 100);
  next();
});

router.afterEach((to, from, next) => {
  // const projectName = computed(() => store.state.title.projectName);
  window.scrollTo(0, 0);
});

export default router;
